
<template>
    <span class="second-btn"
          v-on:click="$emit('click')">
        <span class="second-btn__highlight">
        <slot>

        </slot>
 </span>
    </span>
</template>

<script>
    export default {
        name: "SecondBtn",

    }
</script>

<style lang="scss">
    .second-btn {
        background: #f2f2f2;
        border-radius: 60px;
        color: #666666;
        text-transform: uppercase;
        font-size: 18px;
        text-align: center;
        width: 100%;
        height: 60px;
        display: flex;
        text-decoration: none;
        font-weight: 900;
        user-select: none;
        overflow: hidden;
        letter-spacing: -.3px;

        &__highlight {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 100%;
            height: 100%;
            cursor: pointer;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0.04);
        }

    }

</style>